<div class="row">
    <div class="col-md-12">
        <div class="background-header">
            <img src="/assets/img/banner.jpg">
        </div>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-sm-12">
            <div class="title-main">
                <h3>Giới thiệu</h3>
            </div>
            <div class="text-box">
                <p>Với mục tiêu tiêu đào tạo sinh viên vững về lý thuyết, mạnh về thực hành; chủ động sáng tạo, có khả
                    năng làm việc độc lập/nhóm và có năng lực giải quyết các vấn đề thuộc chuyên ngành, Khoa luôn lấy
                    “người học là trung tâm” làm phương châm cho mọi hoạt động. Đội ngũ giảng viên của Khoa trẻ trung,
                    năng động và đầy nhiệt huyết với hơn 80% được đào tạo sau đại học tại các trường uy tín trong và
                    ngoài nước, chúng tôi cam kết tạo ra một môi trường thân thiện, là địa chỉ tin cậy cho các bạn sinh
                    viên: nuôi dưỡng và phát triển ước mơ, niềm đam mê học tập và nghiên cứu khoa học, phát huy khả năng
                    cá nhân và được tiếp cận những tri thức chuyên ngành hiện đại; đồng thời là nơi các bạn được thường
                    xuyên rèn luyện về các kỹ năng “mềm” cần thiết để có thể thích ứng với môi trường làm việc chuyên
                    nghiệp trong tương lai, đáp ứng tốt các vị trí việc làm trong lĩnh vực tài chính, ngân hàng cũng như
                    các ngành kinh tế và quản lý khác. Chúng tôi hân hoan chào đón các bạn!
                    Khoa rất mong được hợp tác cùng phát triển với các đơn vị và sự hỗ trợ từ các thầy cô cùng các bạn.

                    Xin trân trọng cám ơn!</p>
            </div>
        </div>
    </div>
</div>
